import { api } from "@breakout/backend/convex/_generated/api"
import type { Maybe } from "@breakout/shared/types/market"
import { usePaginatedQuery } from "convex/react"
import type { TweetSortBy } from "../../lib/types"

interface UseTweetsArgs {
	sortBy: TweetSortBy
	sinceMs: number
	entityKey?: string
	initialNumItems?: number
}

export function useTweets(args: Maybe<UseTweetsArgs>) {
	const initialNumItems = args?.initialNumItems ?? 20

	const { results, status, loadMore, isLoading } = usePaginatedQuery(
		api.domains.tweets.queries.getTweets,
		args
			? {
					sortBy: args.sortBy,
					sinceMs: args.sinceMs,
					...(args.entityKey != null ? { entityKey: args.entityKey } : {}),
				}
			: "skip",
		{ initialNumItems },
	)

	return {
		results,
		status,
		loadMore,
		isLoading,
		hasMore: status === "CanLoadMore" || status === "LoadingMore",
	}
}
